import { Globe } from "lucide-react";
import { LANGUAGES, useI18n } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();
  const active = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`h-9 px-2.5 rounded-full border border-slate-200 dark:border-slate-700 flex items-center gap-1.5 bg-white dark:bg-slate-900 hover:border-[#003DA5] transition-colors text-xs font-semibold text-slate-700 dark:text-slate-200 ${className}`}
          aria-label="Change language"
          data-testid="language-switcher"
        >
          <Globe className="w-3.5 h-3.5" />
          <span className="whitespace-nowrap max-w-[64px] truncate">{active.native}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 max-h-[70vh] overflow-y-auto">
        <DropdownMenuLabel>Language</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            className={l.code === lang ? "font-bold text-[#003DA5]" : ""}
            data-testid={`lang-${l.code}`}
          >
            <span className="flex-1">{l.native}</span>
            <span className="text-[10px] text-slate-400 uppercase tracking-wider">{l.code}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
